"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runWithLowPriority = void 0;

var Scheduler = _interopRequireWildcard(require("scheduler"));

var runWithLowPriority = function runWithLowPriority(cb) {
  return Scheduler.unstable_runWithPriority(Scheduler.unstable_LowPriority, function () {
    cb();
  });
};

exports.runWithLowPriority = runWithLowPriority;